import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { ManagementReservationAdd } from "@/components/features/management/reservation/item/add";

import { useConfirmParams } from "./hooks";

export const ManagementReservationAddPage = () => {
	const result = useConfirmParams();

	const { canRender } = result;
	if (!canRender) return <></>;

	const { hotelID } = result;

	return (
		<PageMeta title="新規予約" url={generatePath(PATHS.HOTEL.MANAGEMENT.RESERVATION.ADD, { hotelID })}>
			<ManagementReservationAdd hotelID={hotelID} />
		</PageMeta>
	);
};
